import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"

function Collapsible({ ...props }: Readonly<React.ComponentProps<typeof CollapsiblePrimitive.Root>>) {
	return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />
}

function CollapsibleTrigger({
	...props
}: Readonly<React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>>) {
	return <CollapsiblePrimitive.CollapsibleTrigger data-slot="collapsible-trigger" {...props} />
}

function CollapsibleContent({
	...props
}: Readonly<React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>>) {
	return <CollapsiblePrimitive.CollapsibleContent data-slot="collapsible-content" {...props} />
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
